import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Session propagation: the access token lives 60 min, the refresh token 7 days.
// On a 401, refresh once (single-flight) and retry the original request — so a
// valid session never surfaces as "Not authenticated" mid-work.
const NO_REFRESH_URLS = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/forgot-password", "/auth/reset-password", "/auth/google"];
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error || {};
    if (
      response?.status === 401 && config && !config._retried
      && !NO_REFRESH_URLS.some((u) => config.url?.includes(u))
    ) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(config);
      } catch {
        // refresh failed — session genuinely expired
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
